import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPAlertBar from '../PDPAlertBar';
import PDPNotifyOnStock from '../PDPNotifyOnStock';
const PDPAlertsSection = t0 => {
  const $ = _c(8);
  const {
    showOutOfStockNotification
  } = t0;
  const t1 = showOutOfStockNotification.eta ? `Sorry - looks like this product has sold out. Don't worry, we estimate this will be restocked on ${showOutOfStockNotification.eta}` : "Sorry, we're sold out of this product!";
  let t2;
  if ($[0] !== t1) {
    t2 = <PDPAlertBar type="error">{t1}</PDPAlertBar>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== showOutOfStockNotification.productId || $[3] !== showOutOfStockNotification.show) {
    t3 = showOutOfStockNotification?.show ? <PDPNotifyOnStock id={showOutOfStockNotification.productId} /> : <div className="PDPAlertsSection__PDPNotifyOnStock-filler" />;
    $[2] = showOutOfStockNotification.productId;
    $[3] = showOutOfStockNotification.show;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
PDPAlertsSection.propTypes = {
  showOutOfStockNotification: PropTypes.shape({
    show: PropTypes.bool,
    productId: PropTypes.number,
    eta: PropTypes.string
  })
};
export default PDPAlertsSection;